import React, { useMemo } from 'react'
import { type TourStep } from 'utils/tour/tour.types'
import { fontWeight } from 'gin-and-tonic/foundation/fontWeight'
import { useDomainMessages } from 'domains/pickup-settings/utils/domain/intl'
export const useRemindMeLaterStep = (): TourStep => {
  const messages = useDomainMessages({
    description: 'pickupSettingsDomain.tours.remindMeLaterStep.detailedTour.description',
    btnLabel: 'pickupSettingsDomain.tours.remindMeLaterStep.detailedTour.nextBtnLabel',
  })

  const step: TourStep = useMemo(
    () => ({
      selector: '#restartTourBtn',
      showPrevButton: false,
      nextButtonLabel: messages.btnLabel,
      title: null,
      beaconPosition: 'bottomLeft',
      position: ({ left, top }) => [left, top - 200],
      description: (
        <div css={{ padding: '15px 0', fontWeight: fontWeight.BOLD }}>{messages.description}</div>
      ),
    }),
    [messages.btnLabel, messages.description]
  )

  return step
}
